import { IPackage } from '@/Interfaces';
import { IValidator } from '@samc/centricity-core';

// Regex to validate package names - allows only alphanumeric characters, spaces, hyphens, underscores, and periods
// eslint-disable-next-line no-useless-escape
const VALID_PACKAGE_NAME_REGEX = /^[^\/\\%$*\[\]{}?^+~@<>|]*$/;

export class PackageValidator implements IValidator<IPackage> {
  public isValid(value: IPackage, shouldValidateName?: boolean): Record<string, string> {
    const validations: Record<string, string> = {};
    if (!value.name) validations.name = 'Name is required';
    if (!value.status) validations.status = 'Status is required';


    if (shouldValidateName) {
      // Validate package name for special characters
      if (!this.isValidPackageName(value.name)) {
        validations.name = 'Name shouldn\'t contain special characters';
      }
    }

    return validations;
  }

  private isValidPackageName(name: string): boolean {
    return VALID_PACKAGE_NAME_REGEX.test(name);
  }
}